import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from './i18n/en';

i18next.addResourceBundle('en', 'createPatientPage', en);

const CreatePatientConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Create Patient',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.PATIENT,
  permission: PERMISSION.CREATE,
  routes: [
    {
      path: '/patient/create',
      component: React.lazy(() => import('./CreatePatient')),
    },
  ],
};

export default CreatePatientConfig;
